import { Moon, Sun } from "flowbite-react-icons/solid";
import { useEffect, useState } from "preact/hooks";

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored) {
      return stored === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [isDark]);

  return (
    <button
      type="button"
      className="absolute top-3 left-3 md:left-[unset] lg:right-3  z-30 btn btn-ghost btn-circle"
      onClick={() => setIsDark(!isDark)}
      aria-label="Toggle theme"
    >
      <div className="relative w-6 h-6 grid place-items-center">
        <Sun
          className={`absolute transition-all duration-500 ${
            isDark ? "-rotate-90 opacity-0" : "rotate-0 opacity-100"
          }`}
        />
        <Moon
          className={`absolute transition-all duration-500 ${
            isDark ? "rotate-0 opacity-100" : "rotate-90 opacity-0"
          }`}
        />
      </div>
    </button>
  );
}
